import React, { useMemo } from 'react';
import { isHtmlContent, sanitizeHtml } from '../utils/sanitizeHtml';

interface RichTextContentProps {
  html: string;
  className?: string;
  as?: 'div' | 'p';
}

const RichTextContent: React.FC<RichTextContentProps> = ({
  html,
  className = '',
  as: Tag = 'div',
}) => {
  const safe = useMemo(() => sanitizeHtml(html), [html]);

  if (!safe || safe === '<br>' || safe === '<br/>') {
    return null;
  }

  if (isHtmlContent(safe)) {
    return (
      <Tag
        className={`rich-text-content ${className}`}
        dangerouslySetInnerHTML={{ __html: safe }}
      />
    );
  }

  return <Tag className={className}>{safe.replace(/<[^>]+>/g, '')}</Tag>;
};

export default RichTextContent;
